<template>
  <div id="button-group-filter" class="buttons" v-if="target">
    <span v-for="(label, key) in collection" :key="key" class="button is-small round" @click="toggleFilter(key)"
      :class="{ 'is-primary is-selected': target.indexOf(key) > -1 }">
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'button-group-filter',
  props: {
    collection: { type: Object, required: true },
    target: { type: Array, required: true }
  },
  methods: {
    toggleFilter (key) {
      var pos = this.target.indexOf(key)
      if (pos > -1) {
        this.target.splice(pos, 1)
      } else {
        this.target.push(key)
      }
    }
  },
  watch: {
    target () {
      this.$emit('change')
    }
  }
}
</script>
<style lang="scss" scoped>
.round {
  text-transform: uppercase;
  font-family: MuseoSans-700;
}

.is-selected {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ButtonGroupFilter.vue